import request  from "../utils/request"

//登录接口
export const login=(data)=>{
    return request.post("/api/v1/login",data)
}


//账号管理模块
export const addAccount=(data)=>{
    return request.post("/api/v1/addAccount",data)
}
export const setAccount=(data)=>{
    return request.post("/api/v1/setAccount",data)
}

export const delAccount=(data)=>{
    return request.post("/api/v1/delAccount",data)
}
export const getAccountList=(data)=>{
    return request.post("/api/v1/getAccountList",data)
}


//历史数据模块
export const getHistory=(data)=>{
    return request.post("/api/v1/getHistory",data)
}

export const deleteHistory=(data)=>{
  return request.post("/api/v1/delHistory",data)
}
//打印管理
export const getBarCode=(data)=>{
    return request.post("/api/v1/product/print",data)
}

//流程管理模块
export const getProcessList=(data)=>{
    return request.get("/api/v1/getProcessList",data)
}

export const addPro=(data)=>{
    return request.post("/api/v1/account/addProcess",data)
}

export const setProcess=(data)=>{
    return request.post("/api/v1/setProcess",data)
}

export const delProcess=(data)=>{
    return request.post("/api/v1/delProcess",data)
}

//生产计划
export const getPlan=(data)=>{
    return request.post("/api/v1/product/getPlan",data)
}

export const addPlan=(data)=>{
    return request.post("/api/v1/product/addPlan",data)
}

export const delPlan=(data)=>{
    return request.post("/api/v1/product/delPlan",data)
}
export const setPlan=(data)=>{
    return request.post("/api/v1/product/setPlan",data)
}


//生产数据管理
export const getProduceList=(data)=>{
    let url=`/api/v1/product/productList?key_word=${data.keyWord}`
    return request.get(url,data)
}

// 删除看板40天不改动数据
export const deleteProduce=()=>{
  return request.post('/api/v1/product/deltype')
}

// 导出excel数据
export const outExcelData=(data)=>{
  return request.post('/api/v1/productMath/throughRate',data)
}

// 删除单挑型号接口
export const deletelModelType=(data)=>{
  return request.post('/api/v1/product/delSingleType',data)
}
export const deletelPlanData=(data)=>{
  return request.post('/api/v1/product/delPlan',data)
}

//报废数据
export const getScrap=(data)=>{
    let url=`/api/v1/product/scrap?key_word=${data.keyWord}`
    return request.get(url,data)
}

//获取看板上计划数量
// http://127.0.0.1:5000/api/v1/product/panelplan
export const getPlanList=(data)=>{
    return request.get("/api/v1/product/panelplan",data)
}

//库存

export const getStockList=(data)=>{
    return request.get("/api/v1/product/stockList",data)
}


export const setStock=(data)=>{
    return request.post("/api/v1/product/stockchg",data)
}

export const delStock=(data)=>{
    return request.post("/api/v1/product/stockdel",data)
}
//库存入库
export const inStock=(data)=>{
    return request.post("/api/v1/product/stockin",data)
}

//基材列表
export const getJCStockList=(data)=>{
    return request.get("/api/v1/product/materialList",data)
}

//基材修改
export const setJC=(data)=>{
    return request.post("/api/v1/product/materialchg",data)
}
//删除基材
export const delJC=(data)=>{
    return request.post("/api/v1/product/materialdel",data)
}
//基材入库
export const addJC=(data)=>{
    return request.post("/api/v1/product/materialin",data)
}


//二次处理
export const secondStock=(data)=>{
    return request.post("/api/v1/product/stockscrap",data)
}


// WEBPACK FOOTER //
// ./src/api/process.js